import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Icon from "../../../../components/Icon";
import PropTypes from "prop-types";
import { CHARACTERS } from "../../../../utils/globals";
import { getMessageSettings } from "../../../../utils/helpers";
import { classNames } from "../../../../utils/helpers";
import { useReplaceMessage } from "../../../../hooks/useReplaceMessage";
import SendTestSMS from "../../../../components/campaigns/sms/SendTestSMS";
import { useCountChars } from "../../../../components/campaigns/hooks/useCountChars";

const MessageTextBox = (props) => {
  const { value, onChange, onBlur, name, isError, errorMsg, fieldsInfo } =
    props;

  const replaceMessage = useReplaceMessage(fieldsInfo);
  const [count, setCount] = useState(0);
  const [messages, setMessages] = useState("");
  const [maxCharacters, setMaxCharacters] = useState(CHARACTERS.DEFAULT);
  const {
    count: countCharsMessage,
    maxCharacters: maxCharactersMessage,
    messages: messagesPreviewSend,
  } = useCountChars(replaceMessage(value), false);

  useEffect(() => {
    const { limit } = getMessageSettings(value);
    setMaxCharacters(limit);
    setCount(value ? value.length : 0);
    setMessages(value ? Math.ceil(value.length / limit) : 0);
  }, [value]);

  return (
    <>
      <div className="bg-gray-300 rounded-lg px-3 py-2 flex items-start mb-1">
        <Icon icon="info" className="text-gray-900 mt-0.5 shrink-0" />
        <span className="ml-2 text-xs text-gray-900 font-normal leading-relaxed">
          Los caracteres especiales aceptados son: # $ % & () * + , / _ - . : ;
          &lt; = &gt; ? ¡ @. El uso de algunos caracteres especiales reduce el
          número máximo de caracteres por SMS.
        </span>
      </div>
      <div className="grid grid-cols-2 gap-6 py-2">
        <div className="col-span-1 min-h-[150px]">
          <label className="block font-bold text-sm mb-2">
            Mensaje
            <span className="text-red-600 mx-1">*</span>
          </label>
          <Form.Control
            as="textarea"
            name={name}
            id={name}
            value={value}
            required
            maxLength={CHARACTERS.LIMIT}
            onChange={onChange}
            placeholder="Cada 160 caracteres o menos, se cobra 1 mensaje"
            style={{ minHeight: "250px" }}
            size="sm"
            onBlur={onBlur}
            isInvalid={isError}
          />
          <Form.Control.Feedback type="invalid">
            {errorMsg}
          </Form.Control.Feedback>
          <div className="flex justify-between items-center mt-2 text-xs text-gray-600">
            <span
              className={classNames("font-semibold", {
                "text-yellow-600": count > CHARACTERS.DEFAULT,
              })}
            >
              {count}/{maxCharacters} Caracteres (Se enviaran {messages} SMS )
            </span>
          </div>
        </div>

        {/* Preview */}
        <div className="col-span-1 min-h-[150px]">
          <label className="block font-bold text-sm mb-2">
            Previsualización
          </label>

          <div
            className="border border-gray-300 rounded-lg bg-white shadow-sm overflow-hidden flex flex-col"
            style={{ minHeight: "250px" }}
          >
            <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center shrink-0">
              <span className="text-sm font-medium text-gray-700">
                1-555-123-4567
              </span>
              <Icon icon="more_vert" className="text-gray-500" />
            </div>

            <div className="preview-content flex-1 p-4 flex flex-col">
              <div className="flex items-start gap-3 flex-1">
                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center shrink-0">
                  <Icon icon="person" className="text-gray-600 text-sm" />
                </div>

                <div className="flex-1 min-w-0 flex flex-col">
                  <div className="bg-blue-100 px-3 py-2 rounded-2xl rounded-tl-none flex-1">
                    <p className="text-[12px] text-gray-900 leading-snug break-words whitespace-pre-wrap overflow-hidden">
                      {replaceMessage(value) ||
                        "Escribe tu mensaje para ver la previsualización"}
                    </p>
                  </div>
                  <span className="text-xs text-gray-500 mt-1 block shrink-0">
                    10:30 AM
                  </span>
                </div>
              </div>
            </div>

            <div className="px-1 py-1 bg-gray-50 border-t border-gray-200 flex justify-center items-center shrink-0">
              <span
                className={classNames("font-semibold text-[12px]", {
                  "text-yellow-600": countCharsMessage > CHARACTERS.DEFAULT,
                })}
              >
                {countCharsMessage}/{maxCharactersMessage} Caracteres (Se
                enviaran {messagesPreviewSend} SMS )
              </span>
            </div>
          </div>
          <SendTestSMS messageWithTemplate={replaceMessage(value)} />
        </div>
      </div>
    </>
  );
};

MessageTextBox.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  template: PropTypes.string,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  isError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  errorMsg: PropTypes.string,
  fieldsInfo: PropTypes.array,
};

export default MessageTextBox;
